import React from'react';/**
 * Used to store temporary state and dispatch needed for the blocking action marker in UP.
 */export var UpBlockingActionMarkerContext=React.createContext();